module.exports = __webpack_public_path__ + "static/media/interview_manager.62fb1ad4.svg";